export default {
  getReceivingOfCultivatedAbolone: (state) => state.receivingOfCultivatedAbolone,
};
